export const PODIUM_QA_PRIORITY_TEXT = {
    description: 'Label text',
    defaultMessage: 'Q&A Priority',
    id: 'oe.attendee.podiumQAPriority'
};

export const PODIUM_QA_PRIORITY_EXPLANATION_TEXT = {
    description: 'Label text',
    defaultMessage: 'Star and Red flag icons will be displayed next to this attendee in OE Podium.' +
        ' Star indicates that the attendee is approved to ask questions and those questions will be prioritised.' +
        ' Red Flag indicates the attendee’s questions will not be taken.',
    id: 'oe.attendee.podiumQAPriorityExplanation'
};

export const BIOGRAPHY_TEXT = {
    id: 'oe.attendee.Biography',
    description: 'Label text',
    defaultMessage: 'Biography'
};

export const PROFILE_IMAGE_TEXT = {
    id: 'oe.attendee.profileImage',
    description: 'Label text',
    defaultMessage: 'Profile Image'
};

export const EXTERNAL_ATTENDEE_ID_TEXT = {
    id: 'oe.attendee.externalId',
    description: 'Label text',
    defaultMessage: 'External Attendee ID'
};

export const PRIORITY_IN_ORGANIZATION_TEXT = {
    id: 'oe.attendee.priorityInOrganization',
    description: 'Label text',
    defaultMessage: 'Priority in Organization'
};

export const ATTENDANCE_METHOD_TEXT = {
    description: 'Label text',
    defaultMessage: 'Attendance Method',
    id: 'oe.attendee.attendanceMethod'
};

export const NO_ORGANIZATIONS_TEXT = {
    id: 'oe.organization.noOrganizations',
    defaultMessage: 'No organizations',
    description: 'Label text'
};

export const NO_MATCHING_SEARCH_CRITERIA_TEXT = {
    id: 'oe.organization.noMatchingSearchCriteria',
    defaultMessage: 'No organizations matching search criteria',
    description: 'Label text'
};

export const ORGANIZATION_TEXT = {
    id: 'oe.common.organization',
    defaultMessage: 'Organization',
    description: 'Label text'
};


export const FIRST_NAME_TEXT = {
    id: 'oe.common.firstName',
    defaultMessage: 'First Name',
    description: 'Label text'
};

export const LAST_NAME_TEXT = {
    id: 'oe.common.lastName',
    defaultMessage: 'Last Name',
    description: 'Label text'
};

export const EMAIL_TEXT = {
    id: 'oe.common.email',
    defaultMessage: 'Email',
    description: 'Label text'
};

export const EMAIL_NOT_PROVIDED_TEXT = {
    id: 'oe.email.notProvided',
    defaultMessage: 'Not Provided',
    description: 'Label text'
};

export const ASSISTANT_EMAIL_TEXT = {
    id: 'oe.common.assistantEmail',
    defaultMessage: 'Assistant Email',
    description: 'Label text'
};

export const QA_NOTES_TEXT = {
    id: 'oe.common.qaNotes',
    defaultMessage: 'Q&A Notes',
    description: 'Label text'
};

export const TITLE_TEXT = {
    id: 'oe.common.title',
    defaultMessage: 'Title',
    description: 'Label text'
};

export const SALUTATION_TEXT = {
    id: 'oe.common.salutation',
    defaultMessage: 'Salutation',
    description: 'Label text'
};

export const PHONE_NUMBER_TEXT = {
    id: 'oe.common.phoneNumber',
    description: 'Label text',
    defaultMessage: 'Phone Number'
};

export const ACCESS_CODE_TEXT = {
    id: 'oe.access.code',
    description: 'Label text',
    defaultMessage: 'Access Code'
};

export const REGISTRATION_STATUS_TEXT = {
    id: 'oe.attendee.registrationStatus',
    description: 'Label text',
    defaultMessage: 'Registration Status'
};

export const NO_ATTENDANCE_TYPE_SELECTED_TEXT = {
    id: 'oe.attendee.noAttendanceTypeSelected',
    description: 'Label text',
    defaultMessage: 'No Method selected'
};
export const ATTENDEE_MAPPED_TEXT = {
    id: 'oe.attendee.mappedToContact',
    description: 'Label text',
    defaultMessage: 'Attendee is mapped to an OE Contact profile.'
};

export const ATTENDEE_NOT_MAPPED_TEXT = {
    id: 'oe.attendee.notMappedToContact',
    description: 'Label text',
    defaultMessage: 'Attendee is not mapped to an OE Contact profile.'
};

export const MANAGE_MAPPING_TEXT = {
    id: 'oe.attendee.manageMapping',
    description: 'Manage Mapping label text',
    defaultMessage: 'Manage mapping'
};